<template>
  <div class="container">
    <div class="filter-container">
      <el-input v-model="listQuery.ip" :placeholder="langTxt('IP搜索')" style="width: 200px" />
      <el-button type="primary" icon="el-icon-search" @click="handleFilter">{{ langTxt('搜索') }}</el-button>
    </div>
    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row :height="height">
      <el-table-column show-overflow-tooltip :label="langTxt('IP')" prop="ip"></el-table-column>
      <el-table-column show-overflow-tooltip :label="langTxt('访问域名')" prop="domain"></el-table-column>
      <el-table-column show-overflow-tooltip :label="langTxt('拉黑时间')" prop="created_at"></el-table-column>

      <el-table-column :label="langTxt('操作')" width="120" class-name="small-padding fixed-width">
        <template slot-scope="{ row, $index }">
          <el-button type="text" size="mini" @click="handleDelete(row, $index)">{{ langTxt('加白') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- // 分页 -->
    <pagination v-if="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.pagesize" @pagination="getList" />
  </div>
</template>
<script>
  export default {
    name: 'BlackIpList',

    data() {
      return {
        listQuery: {
          page: 1,
          pagesize: 20
        },
        total: 0,
        list: null,
        listLoading: true,
        __i18n: {}
      };
    },

    computed: {
      height() {
        return this.$baseTableHeight();
      }
    },

    created() {
      this.getList();
      this.__i18n = this.$i18n.messages[this._i18n.locale];
    },

    methods: {
      // 搜索
      handleFilter() {
        this.getList();
      },

      // 获取列表
      getList() {
        this.listLoading = true;
        this.request.get('/ipblack-list', { params: this.listQuery }).then((ret) => {
          this.list = ret.list;
          this.total = ret.count;
          setTimeout(() => {
            this.listLoading = false;
          }, 200);
        });
      },

      handleDelete(row, index) {
        this.$baseConfirm(this.__i18n.common.deleteTip, this.__i18n.common.tip, async () => {
          this.request.post('/ipblack-remove', row).then(() => {
            this.$message.success(this.__i18n.common.removeSuccess);
            this.list.splice(index, 1);
          });
        });
      }
    }
  };
</script>
